module.exports = __webpack_public_path__ + "img/emqx-logo.7e1254ea.png";